import _ from "lodash";
import services from '@/commons/services';


const state = {
    templates: [],
    searchResult: [],
    llms: [],
};

const mutations = {
    updateState(ctx, params) {
        if (Array.isArray(params)) {
            params.forEach(par => {
                if (par.path) {
                    _.set(ctx, par.path, par.data);
                }
            })
        } else {
            if (params.path) {
                _.set(ctx, params.path, params.data);
            } else if (params.var) {
                ctx[params.var] = params.data;
            }
        }
    },
    setTemplates(state, templates) {
        state.templates = templates || []
    },
    updateTemplate(state, tpl) {
        let tplToUpdate = state.templates.find(it => it.id === tpl.id);
        if (tpl.delete && tplToUpdate) {
            state.templates = state.templates.filter(it => it.id !== tpl.id)
        } else if (tplToUpdate) {
            tplToUpdate = tpl;
            state.templates = _.orderBy(state.templates, 'name')
        } else {
            state.templates.push(tpl);
            state.templates = _.orderBy(state.templates, 'name')
        }
    }
};

const actions = {
    getTemplates(ctx, params = {request: {}}) {
        let req = {
            count: 1000,
            offset: 0,
            filter: _.merge({}, {}, params.request)
        }
        return services.smartsearch_template.list(req).prepare().then(resp => {
            ctx.commit('setTemplates', _.orderBy(resp.data.list, 'name'))
        });
    },
    getLlms(ctx) {
        let req = {
            "count": 100,
            "needFields": [
                "name",
                "description",
                "contextSize",
                "script",
                "templates"
            ]
        }
        return services.llm_completion.scripts(req).prepare().then(resp => {
            ctx.commit('updateState', {
                path: 'llms',
                data: resp.data.list
            })
        });
    },
    invoke(ctx, params) {
        services.smartsearch.invoke(params.request).prepare().then(resp => {
            ctx.commit('updateState', [{
                path: 'searchResult',
                data: resp.data.messages || []
            }])
        })
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
